'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProperty = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createProperty = exports.createProperty = function createProperty(propertyKey, propertyValue) {
  return _q2.default.Promise.resolve(_defineProperty({}, propertyKey, propertyValue));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/createProperty.js
// module id = 71
// module chunks = 3 4 5